<template>
  <div>
    <v-card dark flat height="300px" tile elevation="4">
      <v-col cols="12" md="12" sm="12">
        <v-img
          src="/img/fantasy_lineups_logo.png"
          class="logo mx-auto"
          height="50"
          width="350"
          contain
        />
      </v-col>

      <v-col cols="12" md="12" sm="12">
        <v-img
          src="/img/report.png"
          class="logo mx-auto"
          height="150"
          width="50"
          contain
        />
      </v-col>

      <v-col cols="4" md="3" sm="3" class="mx-auto">
        <p class="text-center ml-4 body-1">
          Payment Failed !!
          <router-link :to="{ name: 'Pricing' }" class="green--text subtitle-1">
            Back to Pricing
          </router-link>
        </p>
      </v-col>
    </v-card>

    <!-- service -->
    <v-col>
      <p class="text-center text-subtitle-1 font-weight-medium">SERVICING</p>
    </v-col>

    <v-row justify="center">
      <v-spacer></v-spacer>
      <!-- draftkings -->
      <v-col cols="12" md="3" sm="4" class="mt-n7">
        <v-img
          src="/img/draftkings-logo.png"
          class="logo mx-auto mt-n10"
          height="150"
          width="150"
          contain
        />
      </v-col>

      <!-- fanduel -->
      <v-col cols="12" md="3" sm="4" class="mt-n7">
        <v-img
          src="/img/fanduel-logo.png"
          class="logo mx-auto mt-n10"
          height="150"
          width="150"
          contain
        />
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <!-- service -->

    <!-- features -->
    <v-col>
      <p class="text-center text-h6 font-weight-bold">FEATURES</p>
    </v-col>

    <v-row class="mx-1">
      <v-col
        class="fdo-card my-2"
        cols="12"
        md="4"
        sm="4"
        v-for="(feature, index) in features"
        :key="index"
      >
        <div class="mx-auto text-center">
          <p class="body-1 font-weight-medium green--text">
            {{ feature.title }}
          </p>
          <span class="caption font-weight-regular">{{ feature.detail }}</span>
        </div>
      </v-col>
    </v-row>
    <!-- features -->
  </div>
</template>

<script>
export default {
  name: "failurePage",
  data() {
    return {
      features: [
        {
          title: "Player Projections",
          detail: "Live Upto the Minute Player Projections",
        },
        {
          title: "Fantasy Lineups DFS Optimizer",
          detail: "NBA, MLB, NHL, NFL",
        },
        {
          title: "Min/Max Exposure",
          detail: "Set Minimum & Maximum Player Exposure",
        },
        { title: "Team Stacks", detail: "Tea Exposures in an Instant" },
        {
          title: 'Expert "Top plays" filters',
          detail: "Premium Insights Giving you an Edge",
        },
        {
          title: "Mass Lineup Creation",
          detail: "Build Hundreds of Lineups in Second",
        },
        { title: "Deep Insights", detail: "Detailed Team & Player Insights" },
        {
          title: "Export Lineups",
          detail: "Export Lineups into Draftkings & Fanduel",
        },
        {
          title: "Easy to use Interface",
          detail: "Modern Simple Straight forward",
        },
      ],
    };
  },

  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("status") == "active") {
      next({ name: "NbaLayout" });
    } else if (localStorage.getItem("status") == "Inactive") {
      next("/login");
    } else {
      next();
    }
  },
};
</script>

<style lang="scss" scoped>
.style-1 {
  del {
    text-decoration: none;
    position: relative;
    &:before {
      content: " ";
      display: block;
      width: 110%;
      border-top: 2px solid rgba(red, 0.8);
      height: 12px;
      position: absolute;
      bottom: 0;
      left: 0;
      transform: rotate(-7deg);
    }
  }
}
.fdo-card {
  transition: all 0.3s ease-in-out 0s;
  border-radius: 12px;
}

.fdo-card:hover {
  transform: translateY(-10px);
  box-shadow: 0px 8px 30px 0px rgba(111, 163, 6, 0.15);
}

.fdo-card:hover .img-container {
  transform: rotate(360deg);
}
</style>
